import { render, staticRenderFns } from "./CustomerListImport.vue?vue&type=template&id=1d67d1ac&"
import script from "./CustomerListImport.vue?vue&type=script&lang=js&"
export * from "./CustomerListImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports